import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

function FlagImg({ code, size = 20 }) {
  return (
    <img
      src={`https://flagcdn.com/w40/${code}.png`}
      alt={code}
      width={size}
      height={Math.round(size * 0.75)}
      className="rounded-sm object-cover"
      style={{ minWidth: size }}
    />
  );
}

export default function LanguageSwitcher({ className = "", dark = false, dropUp = true }) {
  const { lang, setLanguage, LANGUAGES } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang);

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 text-sm transition-colors ${
          dark
            ? "text-white/60 hover:text-white"
            : "text-text-muted hover:text-primary"
        }`}
      >
        <FlagImg code={current?.flagCode} size={20} />
      </button>

      {open && (
        <div className={`absolute right-0 ${dropUp ? 'bottom-full mb-2' : 'top-full mt-2'} bg-white border border-surface-border rounded-xl shadow-lg py-1 min-w-[140px] z-50`}>
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLanguage(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-4 py-2 text-sm transition-colors ${
                lang === l.code
                  ? "bg-primary-50 text-primary font-medium"
                  : "text-text-secondary hover:bg-surface"
              }`}
            >
              <FlagImg code={l.flagCode} size={18} />
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
